import { Grid } from '@mui/material'

import Select from './Select'

const GridSelect = ({
  label,
  field,
  value,
  options,
  optionLabels,
  onChange = () => {},
  md = 6,
}) => (
  <Grid size={{ xs: 12, md }}>
    <Select
      label={label}
      value={value}
      options={options}
      optionLabels={optionLabels}
      onChange={i => onChange(field, i)}
    />
  </Grid>
)

export default GridSelect
